import React, { useEffect, useState, useRef } from "react"
import Portal from "@reach/portal"
import FocusLock from "react-focus-lock"
import { RemoveScroll } from "react-remove-scroll"
import classNames from "classnames"
import styles from "./styles.module.css"

const useModal = (
  isOpen = false,
  animation = true,
  animationDelay = 150,
  onClose = () => {}
) => {
  const [open, setOpen] = useState(isOpen)
  const overlayEl = useRef(0)
  const modalEl = useRef(0)

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick)
    document.addEventListener("keyup", handleEscapeKey)

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
      document.removeEventListener("keyup", handleEscapeKey)
    }
  }, [])

  useEffect(() => {
    handleOpen(isOpen)
  }, [isOpen])

  const handleOutsideClick = (e) => {
    if (
      modalEl.current &&
      !modalEl.current.contains(e.target) &&
      e.button !== 2
    ) {
      const modalRect = modalEl.current.getBoundingClientRect()
      const targetRect = e.target.getBoundingClientRect()

      if (targetRect.left < modalRect.left && targetRect.top < modalRect.top) {
        handleOpen(false)
      }
    }
  }

  const handleEscapeKey = (e) => {
    if (e.keyCode === 27) {
      handleOpen(false)
    }
  }

  const toggleModal = () => {
    handleOpen(!open)
  }

  const handleOpen = (open) => {
    setOpen(open)

    if (!open) onClose()

    // if (open) {
    //   setOpen(true)
    //   setTimeout(() => {
    //     overlayEl.current.style.opacity = "0.5"
    //     modalEl.current.style.transform = "translate(0, 0)"
    //   }, 0)
    // } else {
    //   overlayEl.current.style.opacity = "0"
    //   modalEl.current.style.transform = "translate(0, -25%)"
    //   animation
    //     ? setTimeout(() => setOpen(false), animationDelay)
    //     : setOpen(false)
    // }
  }

  const Modal = ({ children, size = "medium", compact = false }) =>
    open ? (
      <Portal>
        <FocusLock autoFocus returnFocus>
          <RemoveScroll allowPinchZoom>
            <div
              className={styles["modal-overlay"]}
              ref={overlayEl}
              // style={{
              //   transition: animation
              //     ? `opacity ${animationDelay / 1000}s linear`
              //     : "none",
              // }}
            />
            <div
              className={styles["modal-wrapper"]}
              aria-modal
              aria-hidden
              tabIndex={-1}
              role="dialog"
            >
              <div
                className={classNames(styles.modal, styles[`modal-${size}`], {
                  [styles["modal-compact"]]: compact,
                })}
                ref={modalEl}
                // style={{
                //   transform: animation ? "translate(0, -25%)" : "none",
                //   transition: animation
                //     ? `transform ${animationDelay / 1000}s ease-out`
                //     : "none",
                // }}
              >
                {children}
              </div>
            </div>
          </RemoveScroll>
        </FocusLock>
      </Portal>
    ) : null

  const Header = ({ children }) => {
    return (
      <div className={styles["modal-header"]}>
        <h2 className={styles["modal-title"]}>{children}</h2>

        <button
          type="button"
          className={styles["modal-close-button"]}
          data-dismiss="modal"
          aria-label="Close"
          onClick={toggleModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    )
  }

  const Body = ({ children }) => {
    return <div className={styles["modal-body"]}>{children}</div>
  }

  const Footer = ({ children }) => {
    return <div className={styles["modal-footer"]}>{children}</div>
  }

  Modal.Header = Header
  Modal.Body = Body
  Modal.Footer = Footer

  return [Modal, toggleModal, open]
}

export default useModal
